module.exports = __webpack_public_path__ + "img/card-case.74f38689.png";